import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { ErrorBoundary } from "./error-boundary";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).then((registration) => {
      // La PWA instalada puede quedar abierta días: buscar updates periódicamente.
      setInterval(() => void registration.update(), 30 * 60_000);
    });
  });

  // Cuando un deploy activa un SW nuevo, recargamos una sola vez para tomar la
  // versión fresca. En la primera instalación no hay controller previo: no recargar.
  const hadController = navigator.serviceWorker.controller !== null;
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!hadController || refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}
